export default __webpack_public_path__ + "static/media/enyinnaya-ijoma-v2Podcast.ca5d1094.png";